export default function Personal (props) {

    return (
        <svg stroke={props.stroke || '#000'} fill={props.fill || 'transparent'} className={props.className} style={props.style}  xmlns="http://www.w3.org/2000/svg" viewBox="-3 13 42 42">
            <path d="M 8 26 C 8 20 12 16 18 16 C 24 16 28 20 28 26 C 28 32 24 36 18 36 C 12 36 8 31 8 26 M 0 52 C 8 46 16 46 18 46 C 20 46 28 46 36 52"/>
        </svg>
    )

}